<template>
  <div>
    <vs-card class="p-5" v-if="_contractDetail">
      <div class="flex pb-1">
        <div class="flex-1 flex items-center">
          <span class="text-2xl align-middle mr-2">{{ _contractDetail.contractNo }} : {{
              _contractDetail.contractName
            }}</span>
          <vs-chip color="danger" v-if="_contractDetail.badDebt">ปรับหนี้สูญ
            ({{ _contractDetail.badDebtDateShortLocalTh }})
          </vs-chip>
        </div>
        <div class="flex-1">
          <div class="vx-row">
            <div class="vx-col w-full" style="display: flex; justify-content: flex-end;">

              <vx-tooltip text="ยืนยันสัญญา">
                <vs-button color="success" type="filled" icon-pack="feather" icon="icon-check-circle"
                           v-if="visibilityApproved"
                           @click="onPressedChangeStatus(IContractStatus.approved)" class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="แก้ไขสัญญา">
                <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-edit" v-if="visibilityEdit"
                           @click="onPressedRouteToEdit()" class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="ลบข้อมูลสัญญา">
                <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-trash" v-if="visibilityDel"
                           @click="onPressedDel()" class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="ปรับสถานะเป็นร่าง">
                <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-file" v-if="visibilityDraft"
                           @click="onPressedChangeStatus(IContractStatus.draft)" class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="ปรับโครงสร้างหนี้">
                <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-file-plus"
                           v-if="visibilityRestructuring"
                           @click="onPressedChangeStatus(IContractStatus.nplReturn)"
                           class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="ปิดบัญชี">
                <vs-button color="danger" type="filled" icon-pack="feather" icon="icon-file-minus"
                           v-if="visibilityClose" @click="onPressedChangeStatus(IContractStatus.close)"
                           class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="ยกเลิกปิด บช.">
                <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-file-plus"
                           v-if="visibilityReOpen"
                           @click="onPressedChangeStatus(IContractStatus.approved, { action: 'reApproved' })"
                           class="ml-1"></vs-button>
              </vx-tooltip>

              <div style="border-left: 1px solid gray; height: auto; margin: 0 5px;"></div>
              <vx-tooltip text="ไปหน้าปริ้นหรือข้อมุลแนบไฟล์">
                <vs-button color="success" type="filled" icon-pack="feather" icon="icon-printer"
                           @click="onPressedRouteToPrint(_contractDetail.id)"
                           class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="ไปหน้าจัดการเก่า">
                <vs-button color="success" type="filled" icon-pack="feather" icon="icon-settings"
                           v-if="visibilityToTransactionMange"
                           @click="onPressedRouteToTransactionMange()" class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="ไปหน้ารายละเอียดธุรกรรมรายวัน">
                <vs-button color="success" type="filled" icon-pack="feather" icon="icon-menu"
                           @click="onPressedRouteToTransactionHistory()" class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="ดูข้อมูลนักศึกษา / ออก QR ชำระเงิน">
                <vs-button color="success" type="filled" icon-pack="feather" icon="icon-airplay"
                           @click="openStudentView()" class="ml-1"></vs-button>
              </vx-tooltip>
              <div style="border-left: 1px solid gray; height: auto; margin: 0 5px;"></div>

              <vx-tooltip text="รีเฟรชข้อมูล">
                <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-refresh-ccw"
                           @click="onPressedRefreshContractDetail()" class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="ย้อนวันที่คำนวนดอกเบี้ย" v-if="visibilityClearTransactions">
                <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-chevrons-left"
                           @click="clearTransactionsPopup.active = true" class="ml-1"></vs-button>
              </vx-tooltip>
              <vx-tooltip text="คำนวนดอกเบี้ย" v-if="visibilityGenerateTransactions">
                <vs-button color="warning" type="filled" icon-pack="feather" icon="icon-chevrons-right"
                           @click="generateTransactionsPopup.active = true" class="ml-1"></vs-button>
              </vx-tooltip>
            </div>
          </div>
        </div>
      </div>

      <div class="vx-row pb-1">
        <div class="vx-col w-2/3">
          <div class="vx-row mt-4 pl-4">
            <div class="vx-col bordered-group-dotted mr-1 text-center p-1 pr-5 pl-5 ">
              <a class="text-base text-danger text-bold">{{ _contractDetail.accruedFeeRemain | numberFormat }} ฿</a>
              <p class="text-grey text-sm">ค่าธรรมเนียมคงเหลือ</p>
            </div>
            <div class="vx-col bordered-group-dotted mr-1 text-center p-1 pr-5 pl-5  ">
              <a class="text-base text-danger text-bold">{{ _contractDetail.accruedPenaltyRemain | numberFormat }}
                ฿ </a>
              <p class="text-grey text-sm">เบี้ยปรับคงเหลือ</p>
            </div>
            <div class="vx-col bordered-group-dotted mr-1 text-center p-1 pr-5 pl-5  ">
              <a class="text-base text-danger text-bold">{{ _contractDetail.outstandingAmountRemain | numberFormat }}
                ฿</a>
              <p class="text-grey text-sm">ยอดเรียกเก็บค้างชำระ</p>
            </div>
            <div class="vx-col bordered-group-dotted mr-1 text-center p-1 pr-5 pl-5  ">
              <a class="text-base text-success text-bold">{{ _contractDetail.currentPaymentRoundAmount | numberFormat }}
                ฿ <a class="cursor-pointer" @click="onPressedActiveOutstandingBalanceRestructuringRemainModal()">
                  <feather-icon icon="InfoIcon" svgClasses="h-4 w-4"/>
                </a></a>
              <p class="text-grey text-sm">ยอดเรียกเก็บปัจจุบัน</p>
            </div>
            <div class="vx-col bordered-group-dotted mr-1 text-center p-1 pr-5 pl-5  ">
              <a class="text-base text-success text-bold">{{ _contractDetail.expenseRemain | numberFormat }} ฿</a>
              <p class="text-grey text-sm">ค่าใช้จ่ายคงเหลือ</p>
            </div>
            <div class="vx-col bordered-group-dotted mr-1 text-center p-1 pr-5 pl-5  ">
              <a class="text-base text-bold" :class="`${textColorContractSummarizeStatus}`">
                {{ _contractDetail | contractSummarizeStatus }}</a>
              <p class="text-grey text-sm">สถานะลูกหนี้</p>
            </div>
          </div>
        </div>
        <div class="vx-col w-1/3">
          <div class="vx-row mt-0 mr-1 text-right">
            <div class="vx-col w-full">
              <div class="vx-row mt-8 d-flex">
                <div class="w-1/3 text-left text-grey">เงินต้นคงเหลือ</div>
                <div class="w-2/3 text-right">{{ _contractDetail.paidPrinciple | numberFormat }} /
                  {{ _contractDetail.principleRemain | numberFormat }} บาท
                </div>
              </div>
              <div class="vx-row mt-1">
                <vs-progress :percent="_contractDetail.paidPrinciplePercentage" color="success">success</vs-progress>
              </div>
            </div>
          </div>
        </div>
      </div>

      <vs-divider class="my-5"></vs-divider>

      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-tabs>
            <vs-tab label="ข้อมูลสัญญา">
              <ContractInfoTab></ContractInfoTab>
            </vs-tab>
            <vs-tab label="ข้อมูลการติดตามหนี้">
              <DebtTrackingTab></DebtTrackingTab>
            </vs-tab>
            <vs-tab label="ข้อมูลค่าธรรมเนียมและค่าใช้จ่าย">
              <FeeInfoAndExpenseInfoTab></FeeInfoAndExpenseInfoTab>
            </vs-tab>
            <vs-tab label="ข้อมูลการชำระเงิน">
              <PaymentInfoAndPaymentExpenseInfoTab></PaymentInfoAndPaymentExpenseInfoTab>
            </vs-tab>
            <vs-tab label="ข้อมูลตารางสรุปการโอนเงิน">
              <LoanDetailInfoTab></LoanDetailInfoTab>
            </vs-tab>
            <vs-tab label="ข้อมูลแผนการชำระ">
              <PaymentRoundInfoTab></PaymentRoundInfoTab>
            </vs-tab>
          </vs-tabs>
        </div>
      </div>
    </vs-card>

    <vs-prompt
      @accept="onAcceptClearTransactionsModel"
      @cancel="onCancelClearTransactionsModel"
      @close="onCloseClearTransactionsModel"
      color="warning"
      title="เลือกวันที่ต้องการย้อนวันที่คำนวนดอกเบี้ย"
      :active.sync="clearTransactionsPopup.active">
      <div>
        วันที่
        <flat-pickr :config="configDateClearTransactions" v-model="clearTransactionsPopup.date" class="mb-2 w-full"/>
      </div>
    </vs-prompt>

    <vs-prompt
      @accept="onAcceptGenerateTransactionsModel"
      @cancel="onCancelGenerateTransactionsModel"
      @close="onCloseGenerateTransactionsModel"
      color="warning"
      title="เลือกวันที่ต้องการคำนวนดอกเบี้ย"
      :active.sync="generateTransactionsPopup.active">
      <div class="vx-row">
        <div class="vx-col w-3/4">
          วันที่
          <flat-pickr :config="configDateGenerateTransactions" v-model="generateTransactionsPopup.date"
                      class="mb-2 w-full"/>
        </div>
        <div class="vx-col w-1/4">
          <label class="text-sm">วันปัจจุบัน</label>
          <vs-checkbox v-model="generateTransactionsPopup.updateToNow"></vs-checkbox>
        </div>
      </div>
    </vs-prompt>

    <vs-popup
      :active.sync="outstandingBalanceRestructuringRemainModal.active"
      title="ข้อมูลยอดเรียกเก็บยังไม่ได้ชำระคงเหลือ"
      class="custom-popup"
    >
      <div class="mb-5">
        <p>ยอดเรียกเก็บยังไม่ได้ชำระคงเหลือ : {{ _contractDetail.outstandingBalanceRemain | numberFormat }} ฿</p>
        <p>ยอดเรียกเก็บยังไม่ได้ชำระคงเหลือ (ปรับครงสร้างหนี้) :
          {{ _contractDetail.outstandingBalanceRestructuringRemain | numberFormat }} ฿</p>
      </div>
      <div class="popup-footer">
        <vs-button color="success" @click="outstandingBalanceRestructuringRemainModal.active = false">ตกลง</vs-button>
        <vs-button color="danger" @click="outstandingBalanceRestructuringRemainModal.active = false">ยกเลิก</vs-button>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import {Skeleton} from "vue-loading-skeleton";
import { openStudentSupport } from '@/utils/student-support';
import Divider from "@/views/components/vuesax/divider/Divider.vue";
import moment from "moment/moment";
import {IContractStatus, IStatus} from "@/constants/interface";
import {Thai} from "flatpickr/dist/l10n/th";
import flatPickr from "vue-flatpickr-component";
import {round} from "@/utils";

import {createNamespacedHelpers, mapState} from 'vuex';
import ContractInfoTab from "@/views/pages/Accounting/Contract/Detail/Components/ContractInfoTab/index.vue";
import DebtTrackingTab from "@/views/pages/Accounting/Contract/Detail/Components/DebtTrackingTab/index.vue";
import FeeInfoAndExpenseInfoTab
  from "@/views/pages/Accounting/Contract/Detail/Components/FeeInfoAndExpenseInfoTab/index.vue";
import PaymentInfoAndPaymentExpenseInfoTab
  from "@/views/pages/Accounting/Contract/Detail/Components/PaymentInfoAndPaymentExpenseInfoTab/index.vue";
import LoanDetailInfoTab from "@/views/pages/Accounting/Contract/Detail/Components/LoanDetailInfoTab/index.vue";
import PaymentRoundInfoTab from "@/views/pages/Accounting/Contract/Detail/Components/PaymentRoundInfoTab/index.vue";
import {_objectSpread} from "vue-instantsearch/src/util/polyfills";

const {mapActions: mapAccountingActions, mapState: mapAccountingFields} = createNamespacedHelpers('Accounting');
const {mapActions: mapSystemActions} = createNamespacedHelpers('System');

export default {
  components: {
    Divider,
    ContractInfoTab,
    DebtTrackingTab,
    FeeInfoAndExpenseInfoTab,
    PaymentInfoAndPaymentExpenseInfoTab,
    LoanDetailInfoTab,
    PaymentRoundInfoTab,
    Skeleton,
    flatPickr
  },
  data() {
    return {
      clearTransactionsPopup: {
        active: false,
        date: moment().format('DD-MM-YYYY'),
      },
      generateTransactionsPopup: {
        active: false,
        date: moment().format('DD-MM-YYYY'),
        updateToNow: false
      },
      outstandingBalanceRestructuringRemainModal: {
        active: false
      }
    }
  },
  computed: {
    ...mapAccountingFields(['status', 'contractDetail', 'contractDetailFeeDetails']),
    ...mapState(['currentUser']),
    configDateClearTransactions() {
      const vm = this
      let minDate = null
      let maxDate = null

      if (vm.contractDetail != null) {
        const {contractLoanDate} = vm.contractDetail
        if (contractLoanDate) {
          minDate = moment(contractLoanDate).add(1, 'days').format('DD-MM-YYYY')
        }
      }

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    configDateGenerateTransactions() {
      const vm = this
      let minDate = null
      let maxDate = moment().format('DD-MM-YYYY')

      if (vm.contractDetail != null) {
        const {loan} = vm.contractDetail
        const {lastUpdate} = loan
        if (lastUpdate) {
          minDate = moment(lastUpdate).add(1, 'days').format('DD-MM-YYYY')
        }
      }

      return {
        monthSelectorType: "static",
        allowInput: true,
        locale: Thai,
        dateFormat: "d-m-Y",
        minDate,
        maxDate
      }
    },
    IContractStatus() {
      return IContractStatus
    },
    _contractDetail() {
      if (!this.contractDetail) return {
        contractDate: '',
        contractNo: '',
        contractSeq: '',
        contractName: '',
        contractAmount: 0,
        contractStatus: '',
        // custom field
        contractSummarizeStatus: '',
        username: '',
        loan: {
          accruedFeeRemain: 0,
          accruedPenaltyRemain: 0,
          accruedInterestRemain: 0,
          principleRemain: 0,
          balanceRemain: 0,
          outstandingAmountRemain: 0,
          outstandingBalanceRemain: 0,
          outstandingBalanceRestructuringRemain: 0,
          agingNumber: 0,
          loanAmount: 0,
          contractFeeRemain: 0,
          taxAmountRemain: 0,
          processingFeeRemain: 0,
          courtOrderExpenseRemain: 0,
        }
      };
      const {
        id,
        createdWith,
        contractDate,
        contractNo,
        contractSeq,
        contractName,
        contractAmount,
        contractStatus,
        badDebt,
        badDebtDateShortLocalTh,
        // custom field
        contractSummarizeStatus,
        username,
        loan,
        status,
      } = this.contractDetail;
      const {
        accruedFeeRemain,
        accruedPenaltyRemain,
        accruedInterestRemain,
        principleRemain,
        balanceRemain,
        outstandingAmountRemain,
        outstandingBalanceRemain,
        outstandingBalanceRestructuringRemain,
        agingNumber,
        loanAmount,
        contractFeeRemain,
        taxAmountRemain,
        processingFeeRemain,
        courtOrderExpenseRemain,
      } = loan;
      const currentPaymentRoundAmount = round(outstandingBalanceRemain - outstandingAmountRemain, 2);
      const paidPrinciple = loanAmount - principleRemain;
      const paidPrinciplePercentage = round((paidPrinciple / loanAmount) * 100, 2);
      const expenseRemain = contractFeeRemain + taxAmountRemain + processingFeeRemain + courtOrderExpenseRemain;
      return {
        id,
        createdWith,
        contractDate,
        contractNo,
        contractSeq,
        contractName,
        contractAmount,
        contractStatus,
        status,
        // custom field
        contractSummarizeStatus,
        username,
        loan,
        accruedFeeRemain,
        accruedPenaltyRemain,
        accruedInterestRemain,
        principleRemain,
        balanceRemain,
        outstandingAmountRemain,
        outstandingBalanceRemain,
        outstandingBalanceRestructuringRemain,
        agingNumber,
        loanAmount,
        expenseRemain,
        // dynamic variable
        currentPaymentRoundAmount,
        paidPrinciplePercentage,
        badDebt,
        badDebtDateShortLocalTh,
      }
    },
    feeDetails() {
      if (!this.contractDetailFeeDetails) return [];
      return this.contractDetailFeeDetails.map((item) => {
        const {feeType, feeDate, amount, feeDateLocalTh} = item;
        return {
          feeType,
          feeDate,
          amount,
          feeDateLocalTh
        }
      })
    },
    textColorContractSummarizeStatus() {
      return `text-${this.$options.filters.contractSummarizeStatusColor(this._contractDetail.contractSummarizeStatus)}`;
    },
    visibilityApproved() {
      return [IContractStatus.draft].includes(this._contractDetail.contractStatus) && this._contractDetail.status === IStatus.enabled;
    },
    visibilityEdit() {
      return [IContractStatus.draft].includes(this._contractDetail.contractStatus) && this._contractDetail.status === IStatus.enabled;
    },
    visibilityDel() {
      return [IContractStatus.draft].includes(this._contractDetail.contractStatus) && this._contractDetail.status === IStatus.enabled;
    },
    visibilityDraft() {
      return [IContractStatus.approved].includes(this._contractDetail.contractStatus) && this.isRoot && this._contractDetail.status === IStatus.enabled;
    },
    visibilityRestructuring() {
      return [IContractStatus.approved, IContractStatus.npl].includes(this._contractDetail.contractStatus) && !this.isExternalUser && this._contractDetail.status === IStatus.enabled;
    },
    visibilityClose() {
      return [IContractStatus.approved, IContractStatus.npl].includes(this._contractDetail.contractStatus) && !this.isExternalUser && this._contractDetail.status === IStatus.enabled;
    },
    visibilityReOpen() {
      return [IContractStatus.close].includes(this._contractDetail.contractStatus) && this.isRoot && this._contractDetail.status === IStatus.enabled;
    },
    visibilityToTransactionMange() {
      return this.isRoot && this._contractDetail.status === IStatus.enabled;
    },
    visibilityClearTransactions() {
      return [IContractStatus.approved].includes(this._contractDetail.contractStatus) || this.isRoot && this._contractDetail.status === IStatus.enabled;
    },
    visibilityGenerateTransactions() {
      return [IContractStatus.approved].includes(this._contractDetail.contractStatus) || this.isRoot && this._contractDetail.status === IStatus.enabled;
    },
  },
  methods: {
    _objectSpread,
    ...mapAccountingActions(['initializing', 'updateContractStatus', 'deleteContract', 'getContractDetail', 'clearTransactionsContractDetail', 'calculateContractDetail']),
    ...mapSystemActions(['sendOtpEmail']),
    async initData() {
      const {getContractDetail} = this;
      const {id} = this.$route.params;
      await getContractDetail({id});
    },
    async onPressedChangeStatus(contractStatus, options = {}) {
      const vm = this
      const {action} = options;
      const {updateContractStatus, getContractDetail} = vm;
      const changeStatusAction = action ? `${contractStatus}:${action}` : contractStatus;

      switch (changeStatusAction) {
        case IContractStatus.draft: {
          const confirm_code = Math.floor(1000 + Math.random() * 9000);
          const input_code = prompt("กรุณากรอกรหัสยืนยัน " + confirm_code + ` เพื่อยืนยันการ "ปรับสถานะสัญญาเป็นร่าง" `, "");
          if (confirm_code === Number(input_code)) {
            await updateContractStatus({
              id: vm.$route.params.id,
              form: {
                contractStatus: contractStatus,
                remark: "",
              },
              vm
            });
            await getContractDetail({id: vm.$route.params.id});
          } else {
            return false;
          }
          break;
        }

        case IContractStatus.nplReturn: {
          const confirm_code = Math.floor(1000 + Math.random() * 9000);
          const input_code = prompt("กรุณากรอกรหัสยืนยัน " + confirm_code + ` เพื่อยืนยันการ "ปรับโครงสร้างหนี้" `, "");
          if (confirm_code === Number(input_code)) {
            const contract = await updateContractStatus({
              id: vm.$route.params.id,
              form: {
                otpKey: null,
                contractStatus: contractStatus,
                remark: "",
              },
              vm
            });
            await vm.$router.push({name: 'accounting-contract-detail', params: {id: contract.id}});
          } else {
            return false;
          }
          break;
        }

        case IContractStatus.close: {
          const confirm_code = Math.floor(1000 + Math.random() * 9000);
          const input_code = prompt("กรุณากรอกรหัสยืนยัน " + confirm_code + ` เพื่อยืนยันการปิดบัญชี`, "");
          if (confirm_code === Number(input_code)) {
            await updateContractStatus({
              id: vm.$route.params.id,
              form: {
                contractStatus: contractStatus,
                remark: "",
              },
              vm
            });
            await getContractDetail({id: vm.$route.params.id});
          } else {
            return false;
          }
          break;
        }

        case `${IContractStatus.approved}:reApproved`: {
          const confirm_code = Math.floor(1000 + Math.random() * 9000);
          const input_code = prompt("กรุณากรอกรหัสยืนยัน " + confirm_code + ` เพื่อยืนยันการยกเลิกปิด บช.`, "");
          if (confirm_code === Number(input_code)) {
            await updateContractStatus({
              id: vm.$route.params.id,
              form: {
                contractStatus: contractStatus,
                remark: "ยกเลิกปิดบัญชี",
                isReApproved: true,
              },
              vm
            });
            await getContractDetail({id: vm.$route.params.id});
          } else {
            return false;
          }
          break;
        }

        case IContractStatus.approved: {
          const confirm_code = Math.floor(1000 + Math.random() * 9000);
          const input_code = prompt("กรุณากรอกรหัสยืนยัน " + confirm_code + ` เพื่อยืนยันการยืนยันบัญชี`, "");
          if (confirm_code === Number(input_code)) {
            await updateContractStatus({
              id: vm.$route.params.id,
              form: {
                contractStatus: contractStatus,
                remark: "",
              },
              vm
            });
            await getContractDetail({id: vm.$route.params.id});
          } else {
            return false;
          }
          break;
        }
        default:
          return false;
      }
    },
    async onPressedDel() {
      const vm = this;
      const id = vm.$route.params.id;
      const {deleteContract} = vm;
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: async () => {
          await deleteContract({
            form: {
              id,
            },
            vm: vm
          })
          await vm.$router.push(`/customer/borrower`);
        }
      })
    },
    async onPressedActiveOutstandingBalanceRestructuringRemainModal() {
      this.outstandingBalanceRestructuringRemainModal.active = true
    },
    async onPressedRefreshContractDetail() {
      const {getContractDetail} = this;
      const {id} = this.$route.params;
      await getContractDetail({id});
    },
    async onPressedRouteToTransactionMange() {
      await this.$router.push({name: 'accounting-transaction-manage', params: {id: this.$route.params.id}})
    },
    async onPressedRouteToPrint(id) {
      await this.$router.push({name: 'accounting-contract-print', params: {id: id}})
    },
    async onPressedRouteToTransactionHistory() {
      await this.$router.push({name: 'accounting-transaction-view', params: {id: this.$route.params.id}})
    },
    openStudentView() {
      openStudentSupport(this, { contractId: this._contractDetail.id })
    },
    async onPressedRouteToEdit() {
      await this.$router.push({name: 'accounting-contract-edit', params: {id: this.$route.params.id}})
    },
    // Clear Transactions
    async onAcceptClearTransactionsModel() {
      const vm = this;
      const {id: contractId} = this.$route.params;
      const {clearTransactionsContractDetail} = this;
      const date = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.clearTransactionsPopup.date.trim())
      await clearTransactionsContractDetail({
        contractId,
        date,
      })
    },
    onCancelClearTransactionsModel() {
      this.clearTransactionsPopup.active = false
      this.clearTransactionsPopup.date = moment().format('DD-MM-YYYY')
    },
    onCloseClearTransactionsModel() {
      this.clearTransactionsPopup.date = moment().format('DD-MM-YYYY')
    },
    // Generate Transactions
    async onAcceptGenerateTransactionsModel() {
      const vm = this;
      const {id: contractId} = this.$route.params;
      const {calculateContractDetail} = this;
      const updateToDate = vm.$options.filters.convDDMMYYYYToYYYYMMDD(vm.generateTransactionsPopup.date.trim())
      const updateToNow = vm.generateTransactionsPopup.updateToNow;
      await calculateContractDetail({
        contractId,
        updateToDate,
        updateToNow
      })
    },
    onCancelGenerateTransactionsModel() {
      this.generateTransactionsPopup.active = false
      this.generateTransactionsPopup.date = moment().format('DD-MM-YYYY')
    },
    onCloseGenerateTransactionsModel() {
      this.generateTransactionsPopup.date = moment().format('DD-MM-YYYY')
    },
    async onPressedCalculateCustom() {
      alert('calculate')
    },
  },
  watch: {
    status: {
      handler(res) {
        if (res.processing !== null) {
          if (res.processing) {
            this.$vs.loading();
          } else {
            this.$vs.loading.close();
          }
        }
        if (res.success !== null) {
          this.$vs.notify({...res.success})
        } else if (res.error !== null) {
          this.$vs.notify({...res.error})
        }
      },
      deep: true
    },
    '_contractDetail.status': function (val) {
      if (val === IStatus.disabled) {
        this.$router.go(-1);
      }
    },
    '$route.params.id': {
      async handler(id, oldId) {
        if (!id || id === oldId) return;

        const {initializing, initData} = this;
        initializing(true);
        await initData();
        initializing(false);
      }
    },
  },
  async created() {
    const vm = this
    const {initializing, initData} = vm
    initializing(true);
    await initData();
    initializing(false);
  },
}
</script>

<style scoped>
.bordered-group-dotted {
  border: 1px dotted #ddd; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.bordered-group-dotted-danger {
  border: 1px dotted #FF4D4F; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.bordered-group-dotted-success {
  border: 1px dotted #28C76F; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.bordered-group {
  border: 1px solid #ddd; /* Custom border */
  padding: 20px;
  border-radius: 8px; /* Optional: add some rounded corners */
}

.vertical-align3 {
  vertical-align: 3px;
}

.d-flex {
  display: flex;
}

.justify-center {
  justify-content: center;
}

.align-center {
  align-items: center;
}

.custom-popup .vs-popup {
  width: 600px;
}

.popup-content {
  padding: 20px;
}

.popup-footer {
  display: flex;
  justify-content: flex-end;
  padding: 10px 20px;
  border-top: 1px solid #e0e0e0;
}

.popup-footer .vs-button + .vs-button {
  margin-left: 10px;
}
</style>
